module.exports = __webpack_public_path__ + "static/media/handshake.d39eb6a8.jpg";